import { Box, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";
import Text from "../../components/ui/Text";
import { ROUTES } from "../../constants/routes";
import { useAuth } from "../../contexts/AuthContext";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { resetPassword, error, setError } = useAuth();
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [emailError, setEmailError] = useState("");

  // Clear global error when component mounts
  useEffect(() => {
    setError(null);
  }, [setError]);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!email) {
      setEmailError("Email is required");
      return;
    }

    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    try {
      setIsSubmitting(true);
      setEmailError("");
      setError(null);

      const result = await resetPassword(email);

      if (result.success) {
        setSuccess(true);
      }
    } catch (error) {
      setEmailError("Failed to send reset email. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (success) {
    return (
      <>
        <Text variant="pageHeader" sx={{ mb: 2 }}>
          Check your email
        </Text>

        <Text variant="paragraph" sx={{ mb: 4 }}>
          We've sent a password reset link to <strong>{email}</strong>
        </Text>

        <Button
          variant="primary"
          onClick={() => navigate("/signin")}
          sx={{ width: "100%", mb: 2 }}
        >
          Back to Sign In
        </Button>

        <Text variant="paragraph3" sx={{ color: "#666" }}>
          Didn't receive the email? Check your spam folder or{" "}
          <Button
            variant="text"
            onClick={() => setSuccess(false)}
            sx={{ p: 0, textDecoration: "underline" }}
          >
            try again
          </Button>
        </Text>
      </>
    );
  }

  return (
    <>
      {/* Back Button */}
      <Box sx={{ mb: 1 }}>
        <Button variant="back" onClick={() => navigate(ROUTES.SIGNIN)} />
      </Box>
      <Text variant="pageHeader" sx={{ mb: "8px !important" }}>
        Reset password
      </Text>

      <Text variant="paragraph">
        Enter your email address and we'll send you a link to reset your
        password.
      </Text>

      <form onSubmit={handleSubmit}>
        <Stack spacing={3} sx={{ mt: "24px !important" }}>
          <Input
            label="Email"
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError(""); // Clear error when typing
            }}
            error={emailError}
          />

          {error && (
            <Text variant="paragraph3" sx={{ color: "#D32F2F" }}>
              {error}
            </Text>
          )}

          <Button
            type="submit"
            variant="primary"
            disabled={isSubmitting}
            sx={{ width: "100%" }}
          >
            {isSubmitting ? "Sending..." : "Send reset link"}
          </Button>

          {/* <Box sx={{ textAlign: "center" }}>
            <Link to="/signin" style={{ textDecoration: "none" }}>
              <Text variant="paragraph3" sx={{ color: "#1990FF" }}>
                ← Back to Sign In
              </Text>
            </Link>
          </Box> */}
        </Stack>
      </form>
    </>
  );
};

export default ForgotPassword;
